// assets\script.sample-landing-reviews-clean.js.liquid
$(document).ready(() => {
  function is_touch_device() {
    if (screen.width > 1025) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints; // Checks for existence in all browsers and IE 10/11 & Surface
  }
  if (is_touch_device()) {
    $('.clean-reviews-carousel').css({
      display: 'flex',
      flexDirection: 'row',
      overflowX: 'scroll',
      overflowY: 'hidden'
    });
    $('.clean-reviews-carousel .clean-review').css({
      flexShrink: 0,
      height: 'fit-content'
    });
  } else {
    $('.clean-reviews-carousel').flickity({
      freeScroll: false,
      contain: true,
      prevNextButtons: true,
      pageDots: false,
      wrapAround: true,
      autoPlay: false,
      dragThreshold: 5,
      cellAlign: (screen.width < 767 ? 'left' : 'center')
    });
  }
});